import clsx from "clsx";

interface SidebarProps {
    accent: string;
    items: string[];
}

export function Sidebar({
    accent,
    items,
}: SidebarProps) {
    return (
        <aside
            className="flex w-[168px] flex-col justify-between"
            style={{
                background: `${accent}12`,
            }}
        >
            <div>
                <div className="px-6 py-7">
                    <div
                        className="flex h-11 w-11 items-center justify-center rounded-xl text-lg font-bold text-white"
                        style={{
                            background: accent,
                        }}
                    >
                        V
                    </div>
                </div>

                <nav className="space-y-1 px-2">
                    {items.map((item, index) => (
                        <button
                            key={item}
                            className={clsx(
                                "flex w-full items-center gap-3 rounded-xl px-4 py-3 text-left text-sm font-medium transition-all",
                                index === 0
                                    ? "text-white"
                                    : "text-foreground hover:bg-background"
                            )}
                            style={
                                index === 0
                                    ? {
                                          background: accent,
                                      }
                                    : undefined
                            }
                        >
                            <span
                                className={clsx(
                                    "h-2.5 w-2.5 rounded-full",
                                    index === 0
                                        ? "bg-white"
                                        : "bg-muted-foreground"
                                )}
                            />

                            {item}
                        </button>
                    ))}
                </nav>
            </div>

            <div className="p-4">
                <div className="rounded-2xl border border-border bg-card p-4">
                    <div className="h-2 w-24 rounded-full bg-muted" />

                    <div className="mt-3 h-2 w-full rounded-full bg-muted" />

                    <div className="mt-2 h-2 w-5/6 rounded-full bg-muted" />

                    <button
                        className="mt-5 w-full rounded-xl py-2 text-sm font-semibold text-white"
                        style={{
                            background: accent,
                        }}
                    >
                        Generate Report
                    </button>
                </div>
            </div>
        </aside>
    );
}